import styled from 'styled-components'

export const ChartWrapper = styled.figure`
  width: 100%;
  margin-top: ${({ theme }) => theme.spacings[6]};
`
